import React from 'react';
import { Link, useRouterState } from '@tanstack/react-router';

const Footer: React.FC = () => {
  const routerState = useRouterState();

  const scrollToSection = (sectionId: string): void => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const handleSectionClick = (event: React.MouseEvent, sectionId: string): void => {
    if (routerState.location.pathname === '/') {
      event.preventDefault();
      scrollToSection(sectionId);
    }
  };

  return (
    <footer className="bg-bg-darker border-t border-border py-12 mt-20">
      <div className="container">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          <div>
            <h4 className="font-orbitron text-primary-light mb-4">KinkAsylum</h4>
            <p className="text-text-secondary mb-2">Alliance Code: <strong>knki</strong></p>
            <p className="text-text-secondary">Last War Alliance</p>
          </div>
          <div>
            <h4 className="font-orbitron text-primary-light mb-4">Quick Links</h4>
            <ul className="list-none">
              <li className="mb-2">
                <Link
                  to="/"
                  hash="home"
                  className="text-text-secondary no-underline transition-colors hover:text-primary-light"
                  onClick={(e) => handleSectionClick(e, 'home')}
                >
                  Home
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/events" className="text-text-secondary no-underline transition-colors hover:text-primary-light">
                  Events
                </Link>
              </li>
              <li className="mb-2">
                <Link
                  to="/"
                  hash="about"
                  className="text-text-secondary no-underline transition-colors hover:text-primary-light"
                  onClick={(e) => handleSectionClick(e, 'about')}
                >
                  About
                </Link>
              </li>
              <li className="mb-2">
                <Link
                  to="/"
                  hash="rules"
                  className="text-text-secondary no-underline transition-colors hover:text-primary-light"
                  onClick={(e) => handleSectionClick(e, 'rules')}
                >
                  Rules
                </Link>
              </li>
              <li className="mb-2">
                <Link
                  to="/"
                  hash="stats"
                  className="text-text-secondary no-underline transition-colors hover:text-primary-light"
                  onClick={(e) => handleSectionClick(e, 'stats')}
                >
                  Stats
                </Link>
              </li>
              <li className="mb-2">
                <Link
                  to="/"
                  hash="members"
                  className="text-text-secondary no-underline transition-colors hover:text-primary-light"
                  onClick={(e) => handleSectionClick(e, 'members')}
                >
                  Members
                </Link>
              </li>
              <li className="mb-2">
                <Link
                  to="/"
                  hash="faq"
                  className="text-text-secondary no-underline transition-colors hover:text-primary-light"
                  onClick={(e) => handleSectionClick(e, 'faq')}
                >
                  FAQ
                </Link>
              </li>
              <li className="mb-2">
                <Link
                  to="/"
                  hash="join"
                  className="text-text-secondary no-underline transition-colors hover:text-primary-light"
                  onClick={(e) => handleSectionClick(e, 'join')}
                >
                  Join Us
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="font-orbitron text-primary-light mb-4">Powered By</h4>
            <p className="text-text-secondary">Cloudflare Pages & Workers</p>
          </div>
        </div>
        <div className="text-center pt-8 border-t border-border text-text-muted">
          <p>&copy; 2024 KinkAsylum (knki). All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
